import axios from 'axios'

export default {
  search: function (request) {
    return axios.get('/api/representatives/search', { params: request })
  },
  find: function (id) {
    return axios.get('/api/representatives/find?id='+id)
  },
  save: function (data) {
    return axios.post('/api/representatives/save', data)
  },
  delete: function (id) {
    return axios.delete('/api/representatives/delete?id='+id)
  }
}